import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GitHubState, GitHubRepository } from './githubTypes';
import { githubAPI } from './githubAPI';

const initialState: GitHubState = {
  repositories: [],
  currentRepo: null,
  connected: false,
  loading: false,
  error: null,
};

const githubSlice = createSlice({
  name: 'github',
  initialState,
  reducers: {
    setCurrentRepo: (state, action: PayloadAction<GitHubRepository | null>) => {
      state.currentRepo = action.payload;
    },
    clearGitHubError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Status
    builder.addMatcher(
      githubAPI.endpoints.getGitHubStatus.matchFulfilled,
      (state, action) => {
        state.connected = action.payload.connected;
      }
    );
    
    // Get Repositories
    builder.addMatcher(
      githubAPI.endpoints.getRepositories.matchPending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addMatcher(
      githubAPI.endpoints.getRepositories.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.repositories = action.payload;
      }
    );
    builder.addMatcher(
      githubAPI.endpoints.getRepositories.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
      }
    );
    
    // Disconnect
    builder.addMatcher(
      githubAPI.endpoints.disconnectGitHub.matchFulfilled,
      (state) => {
        state.connected = false;
        state.repositories = [];
        state.currentRepo = null;
      }
    );
  },
});

export const { setCurrentRepo, clearGitHubError } = githubSlice.actions;
export default githubSlice.reducer;
